<ng-container *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left me-auto">{{taskSelector.Code}}</h4>
    <div>
      <ng-container *ngIf="mode === 'add' && !readonly">
        <button type="button" class="btn btn-outline-primary" (click)="submit( 'add')">{{t('Add')}}</button>
      </ng-container>
      <ng-container *ngIf="mode === 'edit' && !readonly">
        <div class="btn-group" ngbDropdown *ngLet="taskSelector.Code === ' - ' || !taskSelector.Code ? 'the task selector' : taskSelector.Code as tsCode">
          <button type="button" class="dropdown-toggle btn btn-outline-danger ms-2" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#trash'"></svg>
            {{t('Delete')}}
          </button>
          <div class="dropdown-menu dropdown-menu-sm dropdown-menu-end" ngbDropdownMenu>
            <button type="button" class="dropdown-item" ngbDropdownItem (click)="delete(true)">
              {{t('Delete')}} {{tsCode}} {{t('with instructions')}}
            </button>
            <button type="button" class="dropdown-item" ngbDropdownItem (click)="delete()">
              {{t('Delete only')}} {{tsCode}}, {{t('keep the instructions')}}
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-outline-primary ms-2" (click)="submit( 'change')">{{t('Change')}}</button>
      </ng-container>
      <button type="button" class="btn-close pull-right ms-2" aria-label="Close" (click)="close()">
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group row">
        <label for="code" class="col-3 col-form-label">{{t('Code')}}</label>
        <div class="col-7">
          <input mesAutoFocus type="text" class="form-control" id="code" name="code" [(ngModel)]="taskSelector.Code" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label for="name" class="col-3 col-form-label">{{t('Name')}}</label>
        <div class="col-7">
          <input type="text" class="form-control" id="name" name="name" [(ngModel)]="taskSelector.Name" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label for="code" class="col-3 col-form-label">{{t('Valid Condition')}}</label>
        <div class="col-7">
          <mes-web-expression-formula cssClass="form-control min-wx-256" [expression]="taskSelector.ValidCondition" [readonly]="readonly" name="expression-{{taskSelector.Id}}"></mes-web-expression-formula>
        </div>
      </div>
      <div class="form-group row">
        <label for="Sequence" class="col-3 col-form-label">{{t('Sequence')}}</label>
        <div class="col-2">
          <input type="number" class="form-control" id="Sequence" name="Sequence" [(ngModel)]="taskSelector.Sequence" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row">
        <label for="Sequence" class="col-3 col-form-label">{{t('Source Code')}}</label>
        <div class="col-2">
          <input type="text" class="form-control" id="SourceCode-{{taskSelector.Id}}" name="SourceCode-{{taskSelector.Id}}" [(ngModel)]="taskSelector.SourceCode">
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="card-title d-flex pb-1">
            <h5 class="d-inline-block">{{t('Specs')}}</h5>
          </div>
          <ime-spec-lines-edit [context]="taskSelector"
                               [wasValidated$]="wasValidated$"
                               [readonly]="readonly"></ime-spec-lines-edit>
        </div>
      </div>
    </form>
  </div>
</ng-container>
